import React, { useEffect, useState } from "react";
import { getallCourse, addToCart, addToWishlist } from "../Common/apis";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader.jsx";
import Slider from "react-slick";

const CustomNextArrow = ({ onClick }) => (
  <button className="custom-arrow next" onClick={onClick}>
  <img src="/assets/home/right.svg" alt="" />
  </button>
);

const CustomPrevArrow = ({ onClick }) => (
  <button className="custom-arrow prev" onClick={onClick}>
<img src="/assets/home/left.svg" alt="" />
  </button>
);


function CourseList({courses}) {
  const settings = {
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 3,
    speed: 500,
    autoplay: false,
    infinite: true,
    dots: false,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "28%",
        },
      },
    ],
  };

  let adjustedCourses = [...courses];

if (courses.length === 3) {
  adjustedCourses.push(courses[0]);
}



  const navigate = useNavigate();
  // const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("GISUL_TOKEN");

  // const getData = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await getallCourse();
  //     setCourses(res.data);
  //   } catch (error) {
  //     console.error("Error fetching courses:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   // setLoading(true);
  //   // getallCourse()
  //   //   .then((res) => setCourses(res.data))
  //   //   .catch((err) => console.error("Error fetching courses:", err));
  //   // setLoading(false);
  //   // getData();
  // }, []);

  const addToWish = async (courseId) => {
    if (!token) {
      toast.error("Please login to add course to wishlist.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await addToWishlist({ courseId });
      toast.success("Course added to wishlist!");
    } catch (error) {
      console.error("Error adding to wishlist:", error);
      toast.error("Failed to add course to wishlist.");
    }
    setLoading(false);
  };

  const addtoC = async (courseId) => {
    if (!token) {
      toast.error("Please login to add course to cart.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await addToCart({ courseId, quantity: 1 });
      toast.success("Course added to cart!");
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error("Failed to add course to cart.");
    }
    setLoading(false);
  };

  console.log(courses);

  return (
    <div className="home-cards">
      {loading && <Loader />}
      <div className="max-w-[1040px] md:pb-[94px] pb-[110px] relative w-full mt-[36px] mx-auto">
      <Slider {...settings}>

        {adjustedCourses.length > 0 ? (
          adjustedCourses.map((course) => (
            <div className="">
              <div
                key={course._id}
                className="home-card"
                onClick={() => navigate(`/coursesdetails/${course.slug}`)}
              >
                <img
                  src={course.images[0]}
                  alt={course.name}
                  className="course-image"
                />

                <h3>{course.name}</h3>
                {/* <p>{course.description}</p> */}

                <div className="home-card-btn mt-3">
                  <button className="bt1">{course.duration}</button>
                  <button className="bt2">$ {course.price} USD</button>
                </div>
                <div className="home-card-btn2 flex justify-start gap-[8px]">
                  <button
                    className="cart-btn"
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   if (!token) {
                    //     toast.error("Please login to add course to cart.");
                    //     navigate("/login");
                    //     return;
                    //   }
                    //   addToCart({ courseId: course._id, quantity: 1 })
                    //     .then((res) => {
                    //       console.log(res.data);
                    //       toast.success("Course added to cart!");
                    //     })
                    //     .catch((err) => {
                    //       console.error("Error adding course to cart:", err);
                    //       toast.error("Failed to add course to cart!");
                    //     });
                    // }}
                    onClick={(e) => {
                      e.stopPropagation();
                      addtoC(course._id);
                    }}
                  >
                    <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                  </button>
                  <button
                    className="cart-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      addToWish(course._id);
                    }}
                  >
                    <i className="fa fa-heart" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              &nbsp;
            </div>
          ))
        ) : (
          // <p>Loading courses...</p>
          <></>
        )}
      </Slider>
      </div>
    </div>
  );
}

export default CourseList;
